"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageTimestampFilter = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MessageTimestampFilter = exports.MessageTimestampFilter = function exports(Locale, FriendlyDateRange) {
  return function formatFn(input) {
    if (!input) {
      return '';
    }
    var lastMessageTime = Locale.getLocaleMoment(input);
    var today = (0, _momentTimezone["default"])(FriendlyDateRange.getToday());

    // If the last message received was today, only show time
    if (lastMessageTime.isSame(today, 'day')) {
      return lastMessageTime.format('h:mm a');
    }

    // If the last message received was less than a week ago, only show the day
    if (today.startOf('day').diff(lastMessageTime.startOf('day'), 'days') < 7) {
      return lastMessageTime.format('ddd');
    }

    // If the last message received was in the same calendar year, show abbreviated month and day
    if (lastMessageTime.isSame(today, 'year')) {
      return lastMessageTime.format('MMM DD');
    }
    return lastMessageTime.format('MM/DD/YYYY');
  };
};
MessageTimestampFilter.$inject = ['Locale', 'FriendlyDateRange'];